'use client'

import { cn } from '@repo/ui/lib/utils'
import { CopyButton } from './copy-button.tsx'
import { ExternalLinkTooltip } from './details-field.tsx'

const rowRevealClassName =
  'md:opacity-0 md:group-hover/copyable-value:opacity-100 md:group-focus-within/copyable-value:opacity-100'

export const CopyableValue = ({
  className,
  href,
  hrefTooltip,
  tooltip,
  value,
}: {
  className?: string
  /** Opens the value elsewhere, for example a `mailto:` or `tel:` link. */
  href?: string
  hrefTooltip?: string
  tooltip?: string
  value: string
}) => (
  <div className={cn('group/copyable-value flex min-w-0 items-center gap-1', className)} data-sentry-component="CopyableValue" data-sentry-source-file="copyable-value.tsx">
    <span className="truncate">{value}</span>
    <CopyButton
      className="size-4"
      revealClassName={rowRevealClassName}
      tooltip={tooltip}
      value={value}
    data-sentry-element="CopyButton" data-sentry-source-file="copyable-value.tsx" />
    {href && (
      <ExternalLinkTooltip
        href={href}
        revealClassName={rowRevealClassName}
        size={16}
        target="_self"
        tooltip={hrefTooltip}
      />
    )}
  </div>
)
